import { EnvironmentProviders, importProvidersFrom, makeEnvironmentProviders } from '@angular/core';
import { NgxPiwikProModule } from '@piwikpro/ngx-piwik-pro';
import { environment } from '../environments/environment';

export function providePiwikTracking(): EnvironmentProviders {
  return makeEnvironmentProviders(
    environment.piwikTagPropertyId
      ? [importProvidersFrom(NgxPiwikProModule.forRoot(environment.piwikTagPropertyId, 'https://wienenergie.containers.piwik.pro/'))]
      : [],
  );
}
